import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const store = ({ loader }) => loader;

const makeSelectLoader = () => createSelector(
  store,
  ({ showLoader }) => showLoader,
);

export {
  makeSelectLoader,
};
